import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import BaseButton from "../../components/button/BaseButton";
import {FormattedMessage} from "react-intl";

@observer
class VideoEnded extends Component {

    render() {
        const {onClose} = this.props;
        return (
            <div className="remote remote-waiting">
                <div className={"video-decline"}>
                    <div className={"avatar-icon"}/>
                    <div><FormattedMessage id={'video.chat.something.went.wrong'}/></div>
                    <div className={"video-decline-buttons"}>
                        <BaseButton className="video-decline-close" onClick={onClose}
                                    label={<FormattedMessage id={'video.chat.close'}/>}/>
                    </div>
                </div>
            </div>
        );

    }
}

export default VideoEnded;
